import script from "./journalManage.vue?vue&type=script&setup=true&lang=js"
export * from "./journalManage.vue?vue&type=script&setup=true&lang=js"

import "./journalManage.vue?vue&type=style&index=0&id=2381174e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2381174e"]])

export default __exports__